<div class="external-broker-access">
    <img src="/assets/images/logo-garantor-azul.png" alt="" class="logo">
    <h1 class="message" *ngIf="!error">
        Iniciando sesión en Garantor...
    </h1>
    <div class="error" *ngIf="error">
        <span class="error-title">Error al iniciar sesión</span>
        <span class="error-description">{{ error }}</span>
        <button mat-raised-button class="garantor-button go-to-login" style="width: fit-content; margin: auto;" color="primary" routerLink="/login" *ngIf="errorCode !== 'acceso-agentes.oficina-invalida'">
            Iniciar sesión manualmente
        </button>
    </div>
</div>
